"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sdk = void 0;
const axios_client_1 = require("@invivodf/axios-client");
const entrypoints_1 = require("./entrypoints");
const get_checkout_consignment_delivery_addresses_1 = require("./entrypoints/checkout/get-checkout-consignment-delivery-addresses");
const search_delivery_options_1 = require("./entrypoints/checkout/search-delivery-options");
const sdk = (apiHost, config) => {
    const client = (0, axios_client_1.createAxiosClient)(apiHost, {
        ...config,
        useHttpError: true,
        callerId: config.callerId
    });
    return {
        duplicateList: (0, entrypoints_1.duplicateList)(client),
        getOnePurchaseOrder: (0, entrypoints_1.getOnePurchaseOrder)(client, config.logger),
        getOneShoppingList: (0, entrypoints_1.getOneShoppingList)(client, config.logger),
        addPromoCodeToCart: (0, entrypoints_1.addPromoCodeToCart)(client),
        removePromoCodeFromCart: (0, entrypoints_1.removePromoCodeFromCart)(client),
        addPromoCodeToList: (0, entrypoints_1.addPromoCodeToList)(client),
        removePromoCodeFromList: (0, entrypoints_1.removePromoCodeFromList)(client),
        getDeliveryAddresses: (0, get_checkout_consignment_delivery_addresses_1.getDeliveryAddresses)((0, entrypoints_1.getCheckoutConsignmentHomeDeliveryAddresses)(client), (0, entrypoints_1.getCheckoutConsignmentPickupPointDeliveryAddresses)(client)),
        getHomeDeliveryAddresses: (0, entrypoints_1.getCheckoutConsignmentHomeDeliveryAddresses)(client),
        getPickupPointDeliveryAddresses: (0, entrypoints_1.getCheckoutConsignmentPickupPointDeliveryAddresses)(client),
        searchDeliveryOptions: (0, search_delivery_options_1.searchDeliveryOptions)((0, entrypoints_1.searchHomeDeliveryOptions)(client), (0, entrypoints_1.searchPickupPointDeliveryOptions)(client)),
        searchHomeDeliveryOptions: (0, entrypoints_1.searchHomeDeliveryOptions)(client),
        searchPickupPointDeliveryOptions: (0, entrypoints_1.searchPickupPointDeliveryOptions)(client),
        selectDeliveryOptions: (0, entrypoints_1.selectDeliveryOptions)(client),
        getCheckoutForDelivery: (0, entrypoints_1.getCheckoutForDelivery)(client),
        getCheckoutForPayment: (0, entrypoints_1.getCheckoutForPayment)(client)
    };
};
exports.sdk = sdk;
